// Stockage local durci pour les données sensibles (jetons, utilisateur, appareil de confiance).
// NB (honnêteté sécurité) : il s'agit d'une OBFUSCATION au repos (XOR + base64), pas d'un chiffrement
// résistant à une attaque XSS active (un script injecté peut réutiliser ces mêmes fonctions).
// Objectif : éviter le stockage des jetons EN CLAIR (inspection casuelle, ordinateur partagé, extensions).
// Le mode hors-ligne est préservé (on reste sur localStorage, cf. offlineAuth.js).

const OBF_PREFIX = 'v1::';
const XOR_KEY = 'racinefit-guard-2026';

const xor = (str) => {
  let out = '';
  for (let i = 0; i < str.length; i++) {
    out += String.fromCharCode(str.charCodeAt(i) ^ XOR_KEY.charCodeAt(i % XOR_KEY.length));
  }
  return out;
};

const encode = (value) => {
  try {
    return OBF_PREFIX + btoa(unescape(encodeURIComponent(xor(String(value)))));
  } catch (e) {
    return String(value);
  }
};

const decode = (stored) => {
  if (stored == null) return null;
  // Valeur héritée stockée en clair (migration douce) : renvoyée telle quelle.
  if (!stored.startsWith(OBF_PREFIX)) return stored;
  try {
    return xor(decodeURIComponent(escape(atob(stored.slice(OBF_PREFIX.length)))));
  } catch (e) {
    return null;
  }
};

const rawSet = (key, value) => {
  try { localStorage.setItem(key, encode(value)); } catch (e) { /* quota / privé */ }
};
const rawGet = (key) => {
  try { return decode(localStorage.getItem(key)); } catch (e) { return null; }
};
const rawRemove = (key) => {
  try { localStorage.removeItem(key); } catch (e) { /* noop */ }
};

export const secureStorage = {
  setToken: (v) => rawSet('token', v),
  getToken: () => rawGet('token'),
  setRefreshToken: (v) => rawSet('refresh_token', v),
  getRefreshToken: () => rawGet('refresh_token'),
  setDeviceToken: (v) => rawSet('trusted_device_token', v),
  getDeviceToken: () => rawGet('trusted_device_token') || '',
  removeDeviceToken: () => rawRemove('trusted_device_token'),

  setUser: (obj) => {
    try { rawSet('user', JSON.stringify(obj)); } catch (e) { /* noop */ }
  },
  getUser: () => {
    const raw = rawGet('user');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  },

  clearAuth: () => {
    rawRemove('token');
    rawRemove('user');
    rawRemove('refresh_token');
  },
};

export default secureStorage;
